/**
 * True only for real WAHA-backed Channel::Api inboxes.
 * Generic API channels and official WhatsApp Cloud must not get remote edit.
 * @param {Object|null|undefined} inbox
 * @returns {boolean}
 */
export function isWahaApiInbox(inbox) {
  if (!inbox || typeof inbox !== 'object') return false;
  const channelType = inbox.channel_type || inbox.channelType;
  if (channelType !== 'Channel::Api') return false;
  return Boolean(inbox.additional_attributes?.waha_session_name);
}

/**
 * Official Meta Cloud API inbox (Channel::Whatsapp + whatsapp_cloud).
 * 360dialog (`provider: default`) is a different stack.
 * @param {Object|null|undefined} inbox
 * @returns {boolean}
 */
export function isOfficialWhatsappCloudInbox(inbox) {
  if (!inbox || typeof inbox !== 'object') return false;
  const channelType = inbox.channel_type || inbox.channelType;
  return (
    channelType === 'Channel::Whatsapp' && inbox.provider === 'whatsapp_cloud'
  );
}

/**
 * Channels that can send a WhatsApp reaction from the dashboard.
 * @param {Object|null|undefined} inbox
 * @returns {boolean}
 */
export function inboxSupportsMessageReactions(inbox) {
  return isWahaApiInbox(inbox) || isOfficialWhatsappCloudInbox(inbox);
}
